import { render, staticRenderFns } from "./diwa.vue?vue&type=template&id=16ef0abe&scoped=true&"
import script from "./diwa.vue?vue&type=script&lang=js&"
export * from "./diwa.vue?vue&type=script&lang=js&"
import style0 from "./diwa.vue?vue&type=style&index=0&id=16ef0abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef0abe",
  null
  
)

export default component.exports